// custom-buy-now.js
// Get Platform Fee Variant ID from a data attribute in theme
const feeVariantId = window.platform_fee_variant_id;

document.addEventListener('DOMContentLoaded', () => {
  // Replace this selector with your Buy Now button
  const buyNowBtn = document.querySelector('[data-buy-now-button]');

  if (!buyNowBtn) return;

  buyNowBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = buyNowBtn.closest('form');
    if (!form) return;

    // Get the main product variant ID and quantity from the form
    const formData = new FormData(form);
    const mainVariantId = formData.get('id');
    const mainQuantity = formData.get('quantity') || 1;

    // Your platform fee product variant ID (use the correct variant ID, not product ID)
    const feeVariantId = '7742612930767'; // **Make sure this is a variant ID**, not product ID

    try {
      // Add main product to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: mainVariantId,
          quantity: mainQuantity
        })
      });

      // Add platform fee product to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: feeVariantId,
          quantity: 1
        })
      });

      // Redirect to checkout
      window.location.href = '/checkout';
    } catch (error) {
      console.error('Error adding to cart:', error);
      // fallback: submit the form normally
      form.submit();
    }
  });
});
